import {ReactNode} from 'react';
import {tv} from 'tailwind-variants';
import {cn} from '../../libs';

interface TopbarProps {
  children: ReactNode;
  variant?: 'static' | 'sticky';
}

const topbar = tv({
  base: '-m-10 mb-10 flex items-center gap-3 border-b px-10 py-4',
  variants: {
    variant: {
      static: '',
      sticky: 'sticky top-0 z-50 bg-bg-primary',
    },
  },
});

export const Topbar = ({children, variant = 'static'}: TopbarProps) => {
  return <div className={cn(topbar({variant}))}>{children}</div>;
};
